import PropTypes from 'prop-types';
import React from 'react';
import { TextArea } from '../../../Elements';
import styles from '../../../Document/Document.scss';
import Formsy from 'formsy-react';

export default class DocumentTitleTextArea extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    commitUpdate: PropTypes.func.isRequired,
    closeHandler: PropTypes.func,
    textAlign: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillUnmount() {
    this.props.commitUpdate();
  }

  handleChange(e) {
    this.setState({ title: e.target.value });
    this.props.onChange(e);
  }

  render() {
    return (
      <Formsy.Form onBlur={this.props.closeHandler}>
        <TextArea
          value={this.state.title}
          placeholder={this.props.placeholder}
          rows={1}
          name='title'
          autoComplete='off'
          autoFocus
          fluid
          onChange={this.handleChange}
          className={[
            styles.titleTextArea,
            this.props.textAlign === 'right' ? styles.alignRight : ''
          ].join(' ')}
        />
      </Formsy.Form>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Title/TitleTextArea.js